import { useEffect } from 'react';
import { BASE_ROUTES } from 'core/common/constants';
import { useServices, useUrlLocation } from 'core/common/hooks';

export function useTerms() {
  const { analyticsService } = useServices();

  const { previousLocation } = useUrlLocation();

  useEffect(() => {
    analyticsService.policyPageOpened(BASE_ROUTES.TECH_TERMS, previousLocation);
  }, [analyticsService, previousLocation]);
}
